import { useQuery } from "@apollo/react-hooks";

import { isValidEmailAddress } from "@ds-developer/frontend";

import EmailAddressExistsCheckQuery from "../graph-ql/EmailAddressExistsCheck.graphql";

const useQueryEmailAddressExistsCheck = (emailAddress: string) =>
  useQuery(EmailAddressExistsCheckQuery, {
    variables: {
      emailAddress,
    },
    skip: !isValidEmailAddress(emailAddress),
  });

export default useQueryEmailAddressExistsCheck;
